module.exports = __webpack_public_path__ + "src/assets/games/35/rabbit0050.jpg";